import React, { useState } from "react";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../components/Loader";
import { createAdmin, showToast } from "../Utils/utils";

const CreateAdmin = () => {
    const [loading, setLoading] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("admin");

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const isFormValid =
        firstName.trim() &&
        lastName.trim() &&
        email.trim() &&
        password.trim() &&
        role;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await createAdmin({
                first_name: firstName,
                last_name: lastName,
                email,
                password,
                role,
            });
            if (response.status == 200) {
                showToast("Admin created successfully", "success");
                setTimeout(() => {
                    window.location.href = "/admin";
                }, [1000]);
            } else {
                showToast(response?.data?.message || response?.data, "error");
            }
        } catch (error) {
            console.log(error, "error...");
            setLoading(false);
            showToast(error.message, "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/admin"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Admin</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Add Admin</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <form className="card mb-4" onSubmit={(e) => handleSubmit(e)} autoComplete="off">
                                            <div className="card-header">
                                                <h5 className="mb-0">Add Admin</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label className="form-control-label">First Name</label>
                                                            <input
                                                                className="form-control"
                                                                placeholder="First Name"
                                                                value={firstName}
                                                                onChange={(e) => setFirstName(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label className="form-control-label">Last Name</label>
                                                            <input
                                                                className="form-control"
                                                                placeholder="Last Name"
                                                                value={lastName}
                                                                onChange={(e) => setLastName(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label className="form-control-label">Email</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                placeholder="Email"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                                autoComplete="off"
                                                                name="new-admin-email"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label className="form-control-label">Password</label>
                                                            <input
                                                                type="password"
                                                                className="form-control"
                                                                placeholder="Password"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                autoComplete="new-password"
                                                                name="new-admin-password"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label className="form-control-label">Role</label>
                                                            <select
                                                                className="form-control"
                                                                value={role}
                                                                onChange={(e) => setRole(e.target.value)}
                                                            >
                                                                <option value="super_admin">Super Admin</option>
                                                                <option value="admin">Admin</option>
                                                                <option value="virtual_assistant">Virtual Assistant</option>
                                                                <option value="transaction_cordinator">Transaction cordinator</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button type="submit" className="btn submit-btn mt-4" disabled={loading || !isFormValid}>
                                                    {" "}
                                                    <i className="far fa-paper-plane" /> Create{" "}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default CreateAdmin;
